import BaseModelAPI from '../BaseModelAPI';

export default class PartGoodReceiptCase extends BaseModelAPI {
	static entity = 'partgoodreceiptcase';
	static entityName = 'partgoodreceiptcase';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.partGoodReceiptId = '';
		this.partGoodReceipt = {};
		this.purchaseOrderDetailId = '';
		this.purchaseOrderDetail = {};
		this.partId = '';
		this.part = {};
		this.supplierCaseNumber = '';
		this.controlCardId = '';
		this.controlCard = {};
		this.qtyReceive = 0;
		this.qtyAdjustment = 0;
		this.qtyActual = 0;
		this.qtyPo = 0;
		this.remark = '';
		this.partGoodReceiptDetailId = '';
		this.partGoodReceiptDetail = {};
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.isScanned = '';
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async printMccBatch(this_, id) {
		//const accessToken = this.useAuth ? await this_.$auth.getTokenSilently() : "";

		let _this = this_;
		//let ids = _this.$store.state.dataIds;
		return this_.$http.get(`${this.entityName}/printmccbatch/${id}`)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

	static async printMcc(this_, id) {
		//const accessToken = this.useAuth ? await this_.$auth.getTokenSilently() : "";

		let _this = this_;
		//let ids = _this.$store.state.dataIds;
		return this_.$http.get(`${this.entityName}/printmcc/${id}`)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

	static async recalculateQtyPo(this_, id, model) {
		return this_.$http.put(`${this.entityName}/recalculateQtyPo/${id}`, model)
			.then(response => {
				return response.data;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}
}